// import { io } from 'socket.io-client'

const configuration = {
  iceServers: [
    {
      urls: ['stun:stun1.l.google.com:19302', 'stun:stun2.l.google.com:19302'],
    },
  ],
  iceCandidatePoolSize: 10,
}

// Mock socket (safe placeholder)
const socket = {
  on: () => {},
  emit: () => {},
  connected: false,
}

let pc = null
let localStream = null

export const switchHandlder = (setRemoteVideo) => {
  socket.on('message', (e) => {
    if (!localStream) return

    switch (e.type) {
      case 'offer':
        handleOffer(e, setRemoteVideo)
        break
      case 'answer':
        handleAnswer(e)
        break
      case 'candidate':
        handleCandidate(e)
        break
      case 'ready':
        makeCall(setRemoteVideo)
        break
      case 'bye':
        hangup()
        break
      default:
        break
    }
  })
}

export const startMedia = async (setlocalVideo) => {
  try {
    localStream = await navigator.mediaDevices.getUserMedia({
      video: true,
      audio: { echoCancellation: true },
    })

    if (setlocalVideo) {
      setlocalVideo(localStream)
    }

    socket.emit('message', { type: 'ready' })
  } catch (err) {
    // silently fail or handle UI error
  }
}

export function createPeerConnection(setRemoteVideo) {
  pc = new RTCPeerConnection(configuration)

  pc.onicecandidate = (e) => {
    if (!e.candidate) return

    socket.emit('message', {
      type: 'candidate',
      candidate: e.candidate.candidate,
      sdpMid: e.candidate.sdpMid,
      sdpMLineIndex: e.candidate.sdpMLineIndex,
    })
  }

  pc.ontrack = (e) => {
    if (setRemoteVideo && e.streams[0]) {
      setRemoteVideo(e.streams[0])
    }
  }

  if (localStream) {
    localStream.getTracks().forEach((track) => {
      pc.addTrack(track, localStream)
    })
  }
}

export async function makeCall(setRemoteVideo) {
  if (pc) return

  try {
    createPeerConnection(setRemoteVideo)

    const offer = await pc.createOffer()
    await pc.setLocalDescription(offer)

    socket.emit('message', {
      type: 'offer',
      sdp: offer.sdp,
    })
  } catch (e) {}
}

export async function handleOffer(offer, setRemoteVideo) {
  if (pc) return

  try {
    createPeerConnection(setRemoteVideo)

    await pc.setRemoteDescription(offer)

    const answer = await pc.createAnswer()
    await pc.setLocalDescription(answer)

    socket.emit('message', {
      type: 'answer',
      sdp: answer.sdp,
    })
  } catch (e) {}
}

export async function handleAnswer(answer) {
  if (!pc) return

  try {
    await pc.setRemoteDescription(answer)
  } catch (e) {}
}

export async function handleCandidate(candidate) {
  if (!pc || !candidate) return

  try {
    await pc.addIceCandidate(candidate)
  } catch (e) {}
}

export async function hangup() {
  if (pc) {
    pc.close()
    pc = null
  }

  if (localStream) {
    localStream.getTracks().forEach((track) => track.stop())
    localStream = null
  }
}

export const hangB = async () => {
  await hangup()
  socket.emit('message', { type: 'bye' })
}
